import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const CREATE_TASK_URL = `${API_URL}/api/v1/parent/task`;
export const TASK_LIST_URL = `${API_URL}/api/v1/parent/tasks`;
export const DELETE_TASK_URL = `${API_URL}/api/v1/parent/delete-kid-task`;
export const COMPLETED_TASK_URL = `${API_URL}/api/v1/parent/complete-task`;

export function createTask(payload) {
    return axiosInstance({
        url: CREATE_TASK_URL,
        method: "POST",
        data: payload
    })
}

export function taskList(payload) {
    return axiosInstance({
        url: TASK_LIST_URL,
        method: "GET",
        params: payload
    })
}

export function taskDelete(payload) {
    return axiosInstance({
        url: DELETE_TASK_URL,
        method: "PUT",
        data: payload
    })
}

export function completedTask(payload) {
    return axiosInstance({
        url: COMPLETED_TASK_URL,
        method: "POST",
        data: payload
    })
}